import { 
    View,
    Badge,
    Button,
    Text,
} from "@aws-amplify/ui-react"
import { react } from "@babel/types"
import styled from "styled-components"

const outerBarWidthPixels = 340;

const BarOuter = styled(View)`
    height:50px;
    width:${outerBarWidthPixels}px;
    border-radius:10px;
    border-width:1px;
    border-color:#CCC;
    border-style:solid;
    overflow:hidden;
    position:relative;
    margin-top:1rem;
`

const BarInner = styled(View)<{ pixels : number, color: string}>`
    height:50px;
    background-color:${props => props.color};
    border-radius:1px;
    border-width:1px;
    width: ${props => props.pixels}px;
    transition: width 0.5s, background-color 1s;
    position:absolute;
    z-index:2;
    top:0;
`

const BarDepletionZone1 = styled(View)<{ pixels : number}>`
    height:50px;
    background-color:#EEE;
    width:${props => props.pixels}px;
    z-index:1;
`

const LabelHolder = styled(View)<{ pixels : number}>`
    display:flex;
    flex-direction:row;
    justify-content:space-between;
    width:${outerBarWidthPixels}px;
`

const Labels = styled(Text)`
    font-size:smaller;
    opacity:0.5;
`


// const BarDepletionZone2 = styled(View)`
//     height:50px;
//     background-color:#E5FDE5;
//     width:40px;
//     z-index:1;
//     position:absolute;
//     top:0;
//     left:300px;
// `


interface ICalorieBarProps {
    maxCalories: number,
    currentCalories: number,
    depletionZoneCalories?: number,
    units?: string,//if not kcal.
}


const barColorBad = {
    r: 242,
    g:229,
    b:48
}

const barColorGood = {
    r: 96,
    g:196,
    b:39
}

const DepletionText = styled(Text)`
    font-style:italic;
    opacity:0.5;
    padding-left:20px;
    padding-top:12px;
    position:static;
    min-width:150px;
`

export const CalorieBar = (props: ICalorieBarProps) => {

    const unitsText = props.units || "kcal"

    const caloriesNeededToTotallyFillBar = props.maxCalories //* (1/0.9)
    const percentageFilled = props.currentCalories / caloriesNeededToTotallyFillBar
    const pixels = Math.floor(outerBarWidthPixels * percentageFilled)
    const depletionPercentage = (props.depletionZoneCalories || 0) / caloriesNeededToTotallyFillBar
    const depletionPixels = Math.floor((outerBarWidthPixels * depletionPercentage))
    
    const barColor = {...barColorBad};
    const howGood = props.currentCalories / props.maxCalories;
    // now calculate delta of each compoment and multipy out to get the color.


    for (const x of ["r", "g", "b"]) {
        const i = x as "r" | "g" | "b"
         const delta = barColorGood[i] - barColorBad[i] ;
         const actual = barColorBad[i] + delta * howGood;
         barColor[i] = actual
    }

    return <View>
        <BarOuter>
            
            { depletionPixels > 1 ? <BarDepletionZone1 pixels={depletionPixels}><DepletionText>depletion zone</DepletionText></BarDepletionZone1> : null}
            <BarInner pixels={pixels} color={`rgba(${barColor.r}, ${barColor.g}, ${barColor.b}, 1.0)`}/>
        </BarOuter>
        <LabelHolder>
            <Labels>0{unitsText}</Labels>
            <Labels>{props.maxCalories.toFixed(0)}{unitsText}</Labels>
        </LabelHolder>
    </View>
}